module.exports = __webpack_public_path__ + "img/38.615c8523.jpg";